import { getReorderDestinationIndex } from "@atlaskit/pragmatic-drag-and-drop-hitbox/util/get-reorder-destination-index"
import type { Edge } from "@atlaskit/pragmatic-drag-and-drop-hitbox/types"

/** Something in an ordered list a screen lets be dragged, told apart by id. */
type Listed = { id: string }

/**
 * Where something new goes when it is dropped on the top or bottom edge of an
 * item in the list: above that item, or below it.
 */
export function placeForDrop(
  items: Listed[],
  targetId: string,
  edge: Edge | null,
): number {
  const index = items.findIndex((item) => item.id === targetId)
  return edge === "bottom" ? index + 1 : index
}

/**
 * The move an item makes when it is dropped on the top or bottom edge of
 * another in the list, or null when the drop leaves it where it was. It is the
 * move the Move buttons make, at whatever distance the drop carries it.
 */
export function moveForDrop(
  items: Listed[],
  draggedId: string,
  targetId: string,
  edge: Edge | null,
): { index: number; by: number } | null {
  const index = items.findIndex((item) => item.id === draggedId)
  const destination = getReorderDestinationIndex({
    startIndex: index,
    indexOfTarget: items.findIndex((item) => item.id === targetId),
    closestEdgeOfTarget: edge,
    axis: "vertical",
  })
  const by = destination - index
  return by === 0 ? null : { index, by }
}
